module.exports = __webpack_public_path__ + "static/images/callout_4.2713ec4a6fe568c5c2c5d5a589703939.jpg";